import React from 'react';
import { Link } from 'react-router-dom';
// nodejs library that concatenates classes
import classNames from 'classnames';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
// core components
import Footer from 'components/Footer/Footer.jsx';
import Button from 'components/CustomButtons/Button.jsx';
// sections for this page
import NavigationBar from 'components/inc/NavigationBar.jsx';
import ProjectList from 'components/ProjectList/ProjectList.jsx';
import Clearfix from 'components/Clearfix/Clearfix.jsx';

import projectListPageStyle from 'assets/jss/projectListPageStyle.jsx';
import styles from 'assets/jss/customStyle.jsx';
import SprintList from '../SprintPage/SprintList';
import Projects from 'components/Admin/Projects.jsx';
import { Container } from '@material-ui/core';

class ProjectLists extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  }
  render() {
    const { classes } = this.props;

    return (
      <main>
        <NavigationBar />
        <Container maxWidth='lg' component='section'>
          <Projects />
          <div className={classes.right}>
            <Link to='/admin/projects'>
              <Button type='button' color='success' round>
                Back
              </Button>
            </Link>
          </div>
        </Container>
      </main>
    );
  }
}

export default withStyles(projectListPageStyle)(ProjectLists);
